import axios from 'axios';

const API_BASE = '/api/schedule';

export const scheduleService = {
  getEvents: async (from, to) => {
    const fromYmd = String(from || '').split('T')[0];
    const toYmd = String(to || '').split('T')[0];
    const response = await axios.get(API_BASE, { params: { from: fromYmd, to: toYmd } });
    return response.data;
  },
};
